<router-outlet></router-outlet>
<!-- <ebw-toast-container class="contenitore-toast" aria-live="polite" aria-atomic="true"></ebw-toast-container> -->


<!-- <ssc-loader class="loading"></ssc-loader> -->
